import { useTranslation } from 'next-i18next'
import MoreImage from '../../../public/images/more.jpg'
import Image from 'next/image'
import {useRouter} from 'next/router'
interface Props {
  featured_categories: any
}
export default function FeaturedCategories({featured_categories}: Props) {
  const router = useRouter();
  const {locale} = useRouter();
  const {t} = useTranslation('common');
  return (
    <div className="bg-white more-section mt-24 py-12 pb-24">
      <h1 className="text-success text-center  font-semibold text-3xl">
        {t('featuredCategories')}
      </h1>
      <div className="more-list container-fluid mx-auto mt-6 lg:grid lg:grid-cols-4  lg:gap-6">
        {featured_categories.map((category: any, index: number) => {
          return (
            <div key={index} className="more-list-item relative mt-4">
              <div className="more-list-text absolute w-full top-0 z-10 pt-6">
                <h2 className="text-white font-bold text-center text-xl">
                  {locale === 'ar' ? category.name?.ar : category.name?.en}
                </h2>
              </div>
              <div className="image relative rounded-md">
                <div className="overlay-blue rounded-md"></div>
                <Image
                  src={
                    process.env.NEXT_PUBLIC_SITE_URL +
                    '/storage/' +
                    category.image
                  }
                  alt="Book"
                  width={200}
                  height={200}
                  className="w-full rounded-md h-[210px] object-cover"
                />
              </div>
              <div className="absolute text-center bottom-6 left-0 right-0 max-w-[80%] mx-auto">
                <button
                  onClick={e => {
                    router.push('/products?categories=' + category.slug)
                  }}
                  className="text-primary py-3 bg-success rounded-md w-full lg:w-auto px-10 font-semibold">
                  {t('exploreCategory')}
                </button>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
